import { useMemo } from 'react';
import { intersection } from 'underscore';

import { useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { selectAdminContacts } from '@/store/slices/channel-admins/selectors';
import { type StrippedBlAdmin } from '@/types/profile.types';
import { EPermissions } from '@/types/permissions.types';

export const CHANNEL_CREW_ROLES = [
  EPermissions.Producer,
  EPermissions.Presenter,
  EPermissions.Moderation,
  EPermissions.Editor,
];

/* crew is simply channel admins with specific roles */
const useSelectChannelCrew = (): StrippedBlAdmin[] => {
  const activeChannel = useAppSelector(getActiveChannel);
  const allAdmins = useAppSelector(selectAdminContacts);

  return useMemo(() => {
    if (!allAdmins?.length) return [];
    if (!activeChannel) return [];

    return allAdmins.filter((admin) => {
      return intersection(CHANNEL_CREW_ROLES, admin?.channels?.[activeChannel] || []).length > 0;
    });
  }, [activeChannel, allAdmins]);
};

export default useSelectChannelCrew;
